module.exports = function() {

  if ($('.global-side-promo').length === 0) {
    return;
  }

  var promo = $('.global-side-promo');
  var promoOpenState = $(promo).attr("data-open");
  var promoToggles = $(promo).find('.global-side-promo__toggle');
  var hasImage = $(promo).find('.global-side-promo__content--with-image').length > 0;
  var content = {
    desktop: {
      text: {
        maxCharCount: hasImage ? 140 : 150,
        content: $(promo).find('.global-side-promo__text--desktop').attr('data-promo-text'),
      },
      title: {
        maxCharCount: 84,
        maxLines: hasImage ? 3 : null,
        content: $(promo).find('.global-side-promo__title--desktop').attr('data-promo-title')
      },
      eyebrowText: {
        maxCharCount: 32,
        content: $(promo).find('.global-side-promo__eyebrow-text--desktop').attr('data-promo-eyebrow-text')
      },
      toggle: {
        maxCharCount: 36,
        content: $(promo).find('.global-side-promo__desktop-toggle p').text()
      }
    },
    tablet: {
      text: {
        maxCharCount: hasImage ? 124 : 120,
        content: $(promo).find('.global-side-promo__text--tablet').attr('data-promo-text')
      },
      title: {
        maxCharCount: hasImage ? 92 : 68,
        content: $(promo).find('.global-side-promo__title--tablet').attr('data-promo-title')
      },
      eyebrowText: {
        maxCharCount: 19,
        content: $(promo).find('.global-side-promo__eyebrow-text--tablet').attr('data-promo-eyebrow-text')
      },
      toggle: {
        maxCharCount: 36,
        content: $(promo).find('.global-side-promo__desktop-toggle p').text()
      }
    },
    mobile: {
      text: {
        maxCharCount: 132,
        content: $(promo).find('.global-side-promo__text--mobile').attr('data-promo-text')
      },
      title: {
        maxCharCount: 92,
        content: $(promo).find('.global-side-promo__title--mobile').attr('data-promo-title')
      },
      eyebrowText: {
        maxCharCount: 30,
        content: $(promo).find('.global-side-promo__eyebrow-text--mobile').attr('data-promo-eyebrow-text')
      },
      toggle: {
        maxCharCount: 52,
        content: $(promo).find('.global-side-promo__mobile-toggle p').text()
      }
    }
  };

  if (window.outerWidth > ICF.Variables.Breakpoints.DesktopSm - 1) {
    $(promo).attr("data-open", true);
    promoOpenState = $(promo).attr("data-open");
  }

  $.each(content, function(key, val) {
    var viewport = key;
    var text = val.text.content;
    var textMaxChar = val.text.maxCharCount;
    var title = val.title.content;
    var titleMaxChar = val.title.maxCharCount;
    var titleMaxLine = val.title.maxLines;
    var eyebrowText = val.eyebrowText.content;
    var eyebrowTextMaxChar = val.eyebrowText.maxCharCount;
    var toggleText = val.toggle.content;
    var toggleMaxChar = val.toggle.maxCharCount;
    
    if(typeof text !== 'undefined' && text.length > textMaxChar) {
      var truncatedText = truncateContent(text, textMaxChar, true);
      
      $(promo).find(`.global-side-promo__text--${viewport}`).text(truncatedText);
    }
    
    if(typeof title !== 'undefined' && title.length > titleMaxChar) {
      var truncatedText = truncateContent(title, titleMaxChar, true);
      
      $(promo).find(`.global-side-promo__title--${viewport}`).text(truncatedText);
    }

    if(typeof eyebrowText !== 'undefined' && eyebrowText.length > eyebrowTextMaxChar) {
      var truncatedText = truncateContent(eyebrowText, eyebrowTextMaxChar, true);
      
      $(promo).find(`.global-side-promo__eyebrow-text--${viewport}`).text(truncatedText);
    }

    if(typeof toggleText !== 'undefined' && toggleText.length > toggleMaxChar) {
      var truncatedText = truncateContent(toggleText, toggleMaxChar, false);
      
      $(promo).find(`.global-side-promo__${viewport}-toggle p`).text(truncatedText);
    }

    if(titleMaxLine !== (undefined || null)) {
      var title = $(promo).find(`.global-side-promo__title--${viewport}`)[0];
      if (typeof title !== 'undefined')
      {
          var lineHeight = parseFloat(window.getComputedStyle(title)['line-height']);
          var truncatedContent = $(title).text().split(' ');

          while (titleMaxLine * lineHeight < title.clientHeight) {
              truncatedContent.pop();
              $(title).text(truncatedContent.join(' ') + '...');
          }
      }      
    }
  });

  function truncateContent(string, maxCharCount, ellipses = false) {
    var truncated;
    
    if(ellipses) {
      truncated = `${string.substring(0, maxCharCount-3).trim()}...`
    } else {
      truncated = string.substring(0, maxCharCount).trim()
    }

    return truncated;
  }
  
  setTimeout(function() {
    $(window).on('scroll', function() {      
      if (($('body')[0].getBoundingClientRect()).top == 0) {
        $(promo).removeClass('scrolled');
      } else {
        $(promo).addClass('scrolled');
      }      
    });
  }, 1000);

  $(window).on('resize', function() {
    if(window.outerWidth > ICF.Variables.Breakpoints.DesktopSm - 1) {
      $('body').css('overflow-y', '');
    } else if (promoOpenState === 'true') {
      $('body').css('overflow-y', 'hidden')
    }
  });

  promoToggles.click(togglePromo);

  $(document).click(function(e) {
    if($(e.target).parents('.global-side-promo').length === 0 && promoOpenState === 'true' && window.outerWidth < ICF.Variables.Breakpoints.DesktopSm - 1 || $(e.target).hasClass('global-side-promo__page-overlay')) togglePromo(e);
  });
  
  function togglePromo(e) {
    e.preventDefault();
    promo.attr("data-open", promoOpenState === 'false' ? true : false);
    promoOpenState = promo.attr("data-open");

    if(promoOpenState === 'true' && window.outerWidth < ICF.Variables.Breakpoints.DesktopSm - 1) {
      $('body').css('overflow-y', 'hidden');
    } else {
      $('body').css('overflow-y', '');
    }
  }
};